// `display: contents` adds no layout box, but CSS custom properties still
// inherit through it — so core components deeper in the tree resolve their
// `var(--color-*)` tokens to the company's brand instead of core's defaults.
import '@styles/variables.css';
import { observer } from 'mobx-react-lite';

import { useStore } from 'models/stores';

import { DEFAULT_FORM_VALUE_COLOR } from '../styles/constants';

const CoreThemeBridge = observer(({ children }) => {
  const { uiStore } = useStore();
  const theme = uiStore.theme;

  const vars = {
    display: 'contents',
    '--color-button-primary': theme.primaryColor,
    '--color-button-primary-hover': theme.primaryColorDarker ?? theme.primaryColor,
    '--button-border-radius': theme.buttonBorderRadius,
    '--form-value-color': theme.formInputColor || DEFAULT_FORM_VALUE_COLOR,
    '--form-label-color': theme.formLabelColor,
    '--file-icon-color': theme.primaryColor,
    '--font-family': theme.fontFamily,
  };

  if (theme.buttonTextColor) {
    vars['--button-color'] = theme.buttonTextColor;
  }

  return <div style={vars}>{children}</div>;
});

export default CoreThemeBridge;
